import { useState } from "react";
import { apiPost } from "../api/api";
import { useNavigate, useParams } from "react-router-dom";

export default function CriarLocal() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [mupi_id, setMupi] = useState("");
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");

  async function submit(e) {
    e.preventDefault();

    await apiPost(`/projetos/${id}/locais/`, {
      mupi_id,
      latitude: parseFloat(lat),
      longitude: parseFloat(lon),
    });

    navigate(`/projetos/${id}`);
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Novo Local</h1>

      <form onSubmit={submit}>
        <input
          placeholder="ID do mupi"
          value={mupi_id}
          onChange={(e) => setMupi(e.target.value)}
        />

        <input
          placeholder="Latitude"
          value={lat}
          onChange={(e) => setLat(e.target.value)}
        />

        <input
          placeholder="Longitude"
          value={lon}
          onChange={(e) => setLon(e.target.value)}
        />

        <button type="submit">Guardar</button>
      </form>
    </div>
  );
}
